import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import classes from "./PhoneInput.module.css"
import { IoIosArrowDown } from 'react-icons/io';
import clsx from 'clsx';
const Phone = ({
  label = 'Mobile Number',
  isOptional = false,
  id,
  value,
  className,
 onChange,
  errorText = '',
  disabled,
  labelStyle,
  ...rest
}) => {
  return (
    <>
      <style>
        {`
        .custom-phone-input .selected-flag .arrow {
  display: none; /* Hide the default arrow */
}
/* */
.custom-arrow-icon {
  margin-left: 5px; /* Adjust the spacing */
  pointer-events: none; /* Prevent the icon from being interactive */
  width: 10px; /* Set your desired width */
  height: 10px; /* Set your desired height */
}
.custom-phone-input {
  border-radius: 20px!important;
  background-color: var(--bg-color) !important;
  border:1px solid var(--bg-color);
}
.custom-phone-input input {
  background: transparent !important;
  height: 59.95px !important;
}
.custom-phone-input .selected-flag .arrow {
  display: none; /* Hide the default arrow */
}

.react-tel-input .flag-dropdown {
  border-color: transparent !important;
  background-color: transparent !important;
}
.react-tel-input .flag-dropdown.open {
  border-color: transparent !important;
  background: transparent !important;
}
.react-tel-input .selected-flag:hover,
.react-tel-input .selected-flag:focus {
  background: transparent !important;
}
.react-tel-input .flag-dropdown.open .selected-flag {
  background: transparent !important;
}
  .selected-flag{
  padding-left:16px !important;
  }
  .react-tel-input .form-control {
  font-family: "NotoSans-regular";
  line-height: 1.4px;
  font-size: 16px;
  padding-left:58px !important;
  }
.custom-phone-input .selected-flag::after {
  content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%236b6f80' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e");
  display: inline-block;
  margin-left: 22px;
  pointer-events: none; /* Prevent the icon from being interactive */
  width: 10px; /* Set your desired width */
  height: 14px; /* Set your desired height */
  vertical-align: middle;
  position: relative;
  top: 50%;
  transform: translateY(calc(-50% - 7px));
}
  .form-control:focus {
  
  box-shadow: none !important;
  border:1px solid var(--bg-color);
  }
// .custom-phone-input:focus-within {
//   border: 1px solid var(--primary-color) !important;
//   background-color: var(--light-blue) !important;
// }
// div.error .custom-phone-input:focus-within {
//   border: 1px solid var(--error-color) !important;
//   background-color: var(--light-red) !important;
// }
// div.error .custom-phone-input {
//   border: 1px solid var(--error-color) !important;
//   background-color: var(--light-red) !important;
// }
div.error .${classes.label}{

color:var(--error-color);
}  
.react-tel-input .selected-flag:hover {
  background-color: transparent !important;
}


// .custom-phone-input-wrapper.disabled .custom-phone-input:focus-within {
//   border: 1px solid var(--secondary-color)!important;
//   background-color: var(--secondary-color) !important;
//     user-select: none;
// }
        `}
      </style>
      <div
        className={clsx(classes.wrapper, 'custom-phone-input-wrapper', className, {
          // error: errorText,
          disabled
        })}>
        {label && (
          <label className={classes.label} htmlFor={`phone-${id}`} style={{...labelStyle }} >
            {label}
            {!isOptional && <span className={'steric'}>{' *'}</span>}
          </label>
        )}
        <PhoneInput
          flagsImagePath="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/"
          country={'pk'} // Default country code
          value={value}
          // onlyCountries={[]} // Restricts input to Pakistan only
          id={`phone-${id}`}
          // disableDropdown={true}
          placeholder={'+92 XXX XXXXXXX'}
          onChange={onChange}
          containerClass={clsx('custom-phone-input')}
          inputStyle={{ width: '100%', border: 'none' }}
          dropdownStyle={{ color: '#000' }} // Adjust dropdown styles if needed
          buttonComponent={
            <div className="custom-arrow-container">
              <IoIosArrowDown className="custom-arrow-icon" />
            </div>
          }
          disabled={disabled}
          {...rest}
        />
        {errorText && <p className="errorText">{errorText}</p>}
      </div>
    </>
  );
};

export default Phone;
